import './DangKyDangNhapMobile.scss'
import { DangNhap } from './DangNhap'
import { DangKy } from './DangKy'
function DangKyDangNhapMobile ({ isOpen, onClose, tab, settab }) {
  const data = [
    {
      name: 'Đăng nhập',
      svg: (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          viewBox='0 0 20 20'
          fill='none'
          height='100%'
          width='100%'
        >
          <path
            fill-rule='evenodd'
            clip-rule='evenodd'
            d='M7.78327 10.2988H3.42242C3.10614 10.2988 2.84961 10.0422 2.84961 9.72594C2.84961 9.40966 3.10614 9.15312 3.42242 9.15312H7.78327L7.15258 8.52231C6.92889 8.29859 6.92898 7.93591 7.15255 7.71219C7.3762 7.48837 7.73886 7.48847 7.96258 7.71216L9.5713 9.32087C9.79502 9.54459 9.79502 9.90731 9.5713 10.131L7.96258 11.7397C7.85489 11.8474 7.70992 11.9077 7.55764 11.9077C7.40517 11.9077 7.26039 11.8476 7.15255 11.7397C6.92895 11.5161 6.92892 11.1533 7.15255 10.9296L7.78327 10.2988ZM10.1144 16.4517V17.2491C10.1144 17.8884 10.4328 18.4405 10.9865 18.7602C11.2532 18.9142 11.5504 19 11.859 19C12.1676 19 12.4648 18.9142 12.7315 18.7602L16.2769 16.7133C16.8307 16.3936 17.149 15.8417 17.149 15.2023V4.74491C17.149 3.78278 16.3667 3 15.4045 3H7.59605C6.6338 3 5.85098 3.78266 5.85098 4.74491V6.94937C5.85098 7.26575 6.10742 7.52222 6.4238 7.52222C6.74023 7.52222 6.99677 7.26584 6.99677 6.94937V4.74491C6.99677 4.41444 7.26555 4.14581 7.59602 4.14581H14.4382L10.9868 6.13869C10.433 6.45844 10.1144 7.01034 10.1144 7.64981V15.3059H7.59605C7.26567 15.3059 6.9968 15.0374 6.9968 14.707V12.7743C6.9968 12.4578 6.74027 12.2015 6.42383 12.2015C6.10745 12.2015 5.85102 12.4579 5.85102 12.7743V14.707C5.85102 15.6692 6.63383 16.4517 7.59608 16.4517H10.1144Z'
            fill='currentColor'
          ></path>
          <path
            fill-rule='evenodd'
            clip-rule='evenodd'
            d='M7.78327 10.2988H3.42242C3.10614 10.2988 2.84961 10.0422 2.84961 9.72594C2.84961 9.40966 3.10614 9.15312 3.42242 9.15312H7.78327L7.15258 8.52231C6.92889 8.29859 6.92898 7.93591 7.15255 7.71219C7.3762 7.48837 7.73886 7.48847 7.96258 7.71216L9.5713 9.32087C9.79502 9.54459 9.79502 9.90731 9.5713 10.131L7.96258 11.7397C7.85489 11.8474 7.70992 11.9077 7.55764 11.9077C7.40517 11.9077 7.26039 11.8476 7.15255 11.7397C6.92895 11.5161 6.92892 11.1533 7.15255 10.9296L7.78327 10.2988ZM10.1144 16.4517V17.2491C10.1144 17.8884 10.4328 18.4405 10.9865 18.7602C11.2532 18.9142 11.5504 19 11.859 19C12.1676 19 12.4648 18.9142 12.7315 18.7602L16.2769 16.7133C16.8307 16.3936 17.149 15.8417 17.149 15.2023V4.74491C17.149 3.78278 16.3667 3 15.4045 3H7.59605C6.6338 3 5.85098 3.78266 5.85098 4.74491V6.94937C5.85098 7.26575 6.10742 7.52222 6.4238 7.52222C6.74023 7.52222 6.99677 7.26584 6.99677 6.94937V4.74491C6.99677 4.41444 7.26555 4.14581 7.59602 4.14581H14.4382L10.9868 6.13869C10.433 6.45844 10.1144 7.01034 10.1144 7.64981V15.3059H7.59605C7.26567 15.3059 6.9968 15.0374 6.9968 14.707V12.7743C6.9968 12.4578 6.74027 12.2015 6.42383 12.2015C6.10745 12.2015 5.85102 12.4579 5.85102 12.7743V14.707C5.85102 15.6692 6.63383 16.4517 7.59608 16.4517H10.1144Z'
            fill='currentColor'
          ></path>
        </svg>
      )
    },
    {
      name: 'Đăng ký',
      svg: (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          viewBox='0 0 20 20'
          fill='none'
          height='100%'
          width='100%'
        >
          <path
            d='M10.4457 11.3596H6.5793C4.60143 11.3596 3 12.961 3 14.9389C3 15.7364 3.6444 16.3808 4.44193 16.3808H12.5831C13.3806 16.3808 14.025 15.7364 14.025 14.9389C14.025 12.961 12.4236 11.3596 10.4457 11.3596Z'
            fill='currentColor'
          ></path>
          <path
            d='M8.51263 10.3387C10.2762 10.3387 11.7059 8.90899 11.7059 7.14538C11.7059 5.38177 10.2762 3.95209 8.51263 3.95209C6.74902 3.95209 5.31934 5.38177 5.31934 7.14538C5.31934 8.90899 6.74902 10.3387 8.51263 10.3387Z'
            fill='currentColor'
          ></path>
          <path
            fill-rule='evenodd'
            clip-rule='evenodd'
            d='M15.1992 9.5002C15.1992 9.94202 15.5574 10.3002 15.9992 10.3002C16.441 10.3002 16.7992 9.94202 16.7992 9.5002V8.3002H17.9992C18.441 8.3002 18.7992 7.94202 18.7992 7.5002C18.7992 7.05837 18.441 6.7002 17.9992 6.7002H16.7992V5.5002C16.7992 5.05837 16.441 4.7002 15.9992 4.7002C15.5574 4.7002 15.1992 5.05837 15.1992 5.5002V6.7002H13.9992C13.5574 6.7002 13.1992 7.05837 13.1992 7.5002C13.1992 7.94202 13.5574 8.3002 13.9992 8.3002H15.1992V9.5002Z'
            fill='currentColor'
          ></path>
        </svg>
      )
    }
  ]
  if (!isOpen) return null
  return (
    <>
      <div className='van-overlay'></div>
      <div className='van-dialog entrance-dialog'>
        <div className='van-dialog__content'>
          <div className='van_dialog_close' onClick={onClose}>
            <i className='icon_close'>
              <svg
                xmlns='http://www.w3.org/2000/svg'
                viewBox='0 0 10 10'
                fill='currentColor'
                height='100%'
                width='100%'
              >
                <path
                  d='M5.91615 4.99997L9.80995 1.10605C10.0634 0.85277 10.0634 0.443246 9.80995 0.189962C9.55667 -0.0633208 9.14714 -0.0633208 8.89386 0.189962L4.99994 4.08388L1.10614 0.189962C0.85274 -0.0633208 0.443335 -0.0633208 0.190051 0.189962C-0.0633505 0.443246 -0.0633505 0.85277 0.190051 1.10605L4.08385 4.99997L0.190051 8.89389C-0.0633505 9.14717 -0.0633505 9.55669 0.190051 9.80998C0.316278 9.93632 0.482246 9.99979 0.648097 9.99979C0.813947 9.99979 0.979797 9.93632 1.10614 9.80998L4.99994 5.91606L8.89386 9.80998C9.0202 9.93632 9.18605 9.99979 9.3519 9.99979C9.51775 9.99979 9.6836 9.93632 9.80995 9.80998C10.0634 9.55669 10.0634 9.14717 9.80995 8.89389L5.91615 4.99997Z'
                  fill='currentColor'
                  fill-opacity='0.8'
                ></path>
              </svg>
            </i>
          </div>
          <div className='dialog_content_container'>
            <div
              className={`tab_panel_van ${
                tab === 'Đăng nhập' ? 'tab-login' : 'tab-register'
              }`}
            >
              {data.map((item, index) => (
                <div
                  className={`tab_panel_tab ${
                    tab === item.name ? 'tab_panel_tab_active' : ''
                  } `}
                  onClick={() => settab(item.name)}
                  key={index}
                >
                  <i className='icondn'>{item.svg}</i>
                  {item.name}
                </div>
              ))}
            </div>
            <div className='dialog_contaner_item'>
              {tab === 'Đăng nhập' ? (
                <DangNhap onClose={onClose} />
              ) : (
                <DangKy tab={tab} settab={settab} />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default DangKyDangNhapMobile
